/* Spring Renaissance · Small Pleasures concepts — shared behaviour.
   1) Ajax add-to-bag for every form[data-sp-buy]: stays on the page, shows "Added · View bag", bumps the header count via the cart:updated event.
   A form with data-sp-items='[{"id":1,"quantity":1},…]' adds several items at once (pairs).
   2) Nothing else global: concept-specific behaviour lives in its own section. */
(function () {
  if (window.__spBaseReady) return;
  window.__spBaseReady = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function wire(form) {
    if (form.dataset.spWired) return;
    form.dataset.spWired = '1';
    var btn = form.querySelector('[data-sp-btn]');
    var msg = form.querySelector('[data-sp-msg]');
    var bag = form.dataset.spBagLabel || 'View bag';
    var added = form.dataset.spAdded || 'Added to your bag.';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!btn || btn.disabled) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = form.dataset.spAdding || 'Adding…';
      if (msg) { msg.hidden = true; msg.classList.remove('sp-buy__msg--err'); }
      var items = form.dataset.spItems ? JSON.parse(form.dataset.spItems) : null;
      fetch(root + 'cart/add.js', items
        ? { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }
        : { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to bag.'); return d; }); })
        .then(function () {
          if (msg) { msg.innerHTML = added + ' <a href="' + root + 'cart">' + bag + '</a>'; msg.hidden = false; }
          document.dispatchEvent(new Event('cart:updated'));
        })
        .catch(function (x) {
          if (msg) { msg.textContent = x.message; msg.classList.add('sp-buy__msg--err'); msg.hidden = false; }
        })
        .then(function () { btn.disabled = false; btn.textContent = label; });
    });
  }
  function wireAll() { document.querySelectorAll('form[data-sp-buy]').forEach(wire); }
  window.spWire = wireAll; /* v4: forms added later (the pin sheet) call this */
  wireAll();
  document.addEventListener('shopify:section:load', wireAll);
})();

/* v7 · motion helpers (27 Oct): rise-in on scroll with stagger, sticky header that hides on the way down, gallery fade, Add to bag feedback.
   Opacity and transform only. With reduced motion only the bag feedback hooks stay (their CSS is switched off) and every block stays visible. */
(function () {
  if (window.__srMotion) return;
  window.__srMotion = true;
  var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');
  var RM = !!(rm && rm.matches);

  /* --- Add to bag: pulse the button, pop the bag count --- */
  document.addEventListener('submit', function (e) {
    var b = e.target && e.target.querySelector && e.target.querySelector('[data-sp-btn]'); if (b) b.setAttribute('data-sp-just', '1');
  }, true);
  document.addEventListener('cart:updated', function () {
    var bag = document.querySelector('.srh__bag');
    if (bag) { bag.classList.remove('sr-bump'); void bag.offsetWidth; bag.classList.add('sr-bump'); setTimeout(function () { bag.classList.remove('sr-bump'); }, 700); }
    var b = document.querySelector('[data-sp-btn][data-sp-just]');
    if (b) { b.classList.remove('is-added'); void b.offsetWidth; b.classList.add('is-added'); b.removeAttribute('data-sp-just'); setTimeout(function () { b.classList.remove('is-added'); }, 800); }
  });
  if (RM) return;

  /* --- sticky header: down = hide, any move up = show; no flicker near the top --- */
  var hg = document.getElementById('header-group'), last = window.pageYOffset || 0, tick = false, off = false;
  function hdr() {
    tick = false;
    var y = Math.max(0, window.pageYOffset || 0), dy = y - last, h = hg ? hg.offsetHeight : 80;
    if (y <= h) { if (off) { off = false; hg.classList.remove('sr-hdr-off'); } last = y; return; }
    if (dy > 6 && !off && !document.documentElement.style.overflow) { off = true; hg.classList.add('sr-hdr-off'); last = y; }
    else if (dy < -1 && off) { off = false; hg.classList.remove('sr-hdr-off'); last = y; }
    else if ((dy > 0 && off) || (dy < 0 && !off)) last = y;
  }
  if (hg) addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(hdr); } }, { passive: true });

  /* --- rise into view with a stagger --- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      var n = 0;
      es.forEach(function (e) { if (!e.isIntersecting) return; var t = e.target; t.style.setProperty('--rd', Math.min(n * 90, 450) + 'ms'); n++; t.classList.add('is-seen'); io.unobserve(t); });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    var SEL = '.sr-pin,.sr-spread__img,.sr-spread__t,.srl__in,.sp2d__mod,.lvl-water__in,.lvl-shelf__in,.lvl-facts__in,.lvl-pair__in,.lvl-faq__in,.lvl-bundle__in,.srm__h,.srm__foot';
    var arm = function () {
      document.querySelectorAll(SEL).forEach(function (el) {
        if (el.classList.contains('sr-rise') || el.querySelector('.sp2d__bar,.lvl-sticky,.srh__dr')) return;
        var r = el.getBoundingClientRect();
        if (r.top < innerHeight * 0.92 && r.bottom > 0) return;
        el.classList.add('sr-rise'); io.observe(el);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
    document.addEventListener('shopify:section:load', arm);
  }

  /* --- galleries: --vis (0..1) per slide while the track scrolls --- */
  function gallery(tr) {
    var slides = [].slice.call(tr.children), t = false;
    function upd() { t = false; var w = tr.clientWidth || 1, x = tr.scrollLeft; slides.forEach(function (s) { var v = 1 - Math.min(1, Math.abs(s.offsetLeft - tr.offsetLeft - x) / w); s.style.setProperty('--vis', v.toFixed(3)); }); }
    tr.addEventListener('scroll', function () { if (!t) { t = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }
  function galleries() { document.querySelectorAll('.sp2d__track,.lvl-hero__track').forEach(function (tr) { if (!tr.dataset.srg) { tr.dataset.srg = '1'; gallery(tr); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', galleries); else galleries();
})();
